import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { useMemo } from "react";
import { ExperienceIdView } from "@/lib/features/ExperienceIdView";
import { trpc } from "@/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/upplevelser/$slug")({
  component: ExperienceDetailPage
});
function ExperienceDetailPage() {
  const $ = _c(6);
  const {
    slug
  } = Route.useParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.experiences.public.queryOptions({});
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: experiences
  } = useQuery(t0);
  let t1;
  if ($[1] !== experiences || $[2] !== slug) {
    t1 = experiences?.find(exp => exp.titleSlug === slug);
    $[1] = experiences;
    $[2] = slug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const experience = t1;
  if (!experience) {
    throw notFound();
  }
  let t2;
  if ($[4] !== experience) {
    t2 = /*#__PURE__*/_jsx(ExperienceIdView, {
      experience: experience
    });
    $[4] = experience;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}